export const SellLogo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="100%"
      height="100%"
      viewBox="0 0 578 485"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_10235_2180)">
        <rect
          x="100"
          y="77"
          width="400"
          height="300"
          rx="16"
          transform="rotate(4 100 77)"
          fill="white"
          shapeRendering="crispEdges"
        />
        <rect
          x="111.134"
          y="89.8079"
          width="122.667"
          height="89.3333"
          rx="4"
          transform="rotate(4 111.134 89.8079)"
          fill="#FFE4E6"
        />
        <rect
          x="122.816"
          y="152.108"
          width="36"
          height="4"
          rx="2"
          transform="rotate(4 122.816 152.108)"
          fill="#FF637E"
        />
        <rect
          x="122.258"
          y="160.088"
          width="52"
          height="4"
          rx="2"
          transform="rotate(4 122.258 160.088)"
          fill="#FF637E"
        />
        <rect
          x="237.492"
          y="98.6437"
          width="122.667"
          height="89.3333"
          rx="4"
          transform="rotate(4 237.492 98.6437)"
          fill="#FAE8FF"
        />
        <rect
          x="248.616"
          y="168.924"
          width="52"
          height="4"
          rx="2"
          transform="rotate(4 248.616 168.924)"
          fill="#ED6AFF"
        />
        <rect
          x="363.85"
          y="107.479"
          width="122.667"
          height="89.3333"
          rx="4"
          transform="rotate(4 363.85 107.479)"
          fill="#D0FAE5"
        />
        <rect
          x="375.533"
          y="169.78"
          width="34"
          height="4"
          rx="2"
          transform="rotate(4 375.533 169.78)"
          fill="#00D492"
        />
        <rect
          x="374.975"
          y="177.76"
          width="34"
          height="4"
          rx="2"
          transform="rotate(4 374.975 177.76)"
          fill="#00D492"
        />
        <path
          d="M104.174 189.338C104.333 187.066 104.412 185.93 104.922 185.096C105.351 184.394 105.987 183.841 106.742 183.513C107.639 183.125 108.775 183.204 111.047 183.363L220.567 191.021C222.839 191.18 223.975 191.26 224.809 191.769C225.511 192.199 226.064 192.835 226.391 193.59C226.78 194.486 226.701 195.623 226.542 197.895L221.209 274.162C221.05 276.434 220.97 277.571 220.46 278.404C220.031 279.106 219.395 279.659 218.64 279.987C217.744 280.375 216.607 280.296 214.335 280.137L104.816 272.479C102.543 272.32 101.407 272.24 100.574 271.731C99.8714 271.301 99.3187 270.665 98.9911 269.91C98.6023 269.014 98.6818 267.878 98.8407 265.605L104.174 189.338Z"
          fill="#FEF9C2"
        />
        <rect
          x="115.748"
          y="253.194"
          width="80"
          height="4"
          rx="2"
          transform="rotate(4 115.748 253.194)"
          fill="#FDC700"
        />
        <path
          d="M230.532 198.174C230.691 195.902 230.77 194.765 231.28 193.932C231.71 193.23 232.345 192.677 233.101 192.349C233.997 191.961 235.133 192.04 237.406 192.199L346.925 199.857C349.197 200.016 350.333 200.096 351.167 200.605C351.869 201.035 352.422 201.671 352.749 202.426C353.138 203.322 353.059 204.458 352.9 206.731L347.567 282.998C347.408 285.27 347.328 286.406 346.819 287.24C346.389 287.942 345.753 288.495 344.998 288.822C344.102 289.211 342.966 289.132 340.693 288.973L231.174 281.315C228.902 281.156 227.765 281.076 226.932 280.567C226.23 280.137 225.677 279.501 225.349 278.746C224.961 277.85 225.04 276.713 225.199 274.441L230.532 198.174Z"
          fill="#ECFCCA"
        />
        <rect
          x="242.664"
          y="254.05"
          width="58"
          height="4"
          rx="2"
          transform="rotate(4 242.664 254.05)"
          fill="#9AE600"
        />
        <rect
          x="242.106"
          y="262.03"
          width="24"
          height="4"
          rx="2"
          transform="rotate(4 242.106 262.03)"
          fill="#9AE600"
        />
        <path
          d="M356.89 207.01C357.049 204.737 357.128 203.601 357.638 202.768C358.068 202.065 358.704 201.513 359.459 201.185C360.355 200.796 361.491 200.876 363.764 201.035L473.283 208.693C475.555 208.852 476.692 208.931 477.525 209.441C478.227 209.871 478.78 210.506 479.108 211.262C479.496 212.158 479.417 213.294 479.258 215.567L473.925 291.834C473.766 294.106 473.687 295.242 473.177 296.076C472.747 296.778 472.111 297.331 471.356 297.658C470.46 298.047 469.324 297.968 467.051 297.809L357.532 290.15C355.26 289.991 354.123 289.912 353.29 289.402C352.588 288.973 352.035 288.337 351.707 287.582C351.319 286.685 351.398 285.549 351.557 283.277L356.89 207.01Z"
          fill="#E0E7FF"
        />
        <rect
          x="368.464"
          y="270.866"
          width="34"
          height="4"
          rx="2"
          transform="rotate(4 368.464 270.866)"
          fill="#7C86FF"
        />
        <path
          d="M97.6633 282.444C97.8222 280.172 97.9017 279.035 98.4114 278.202C98.8409 277.5 99.4767 276.947 100.232 276.619C101.128 276.231 102.264 276.31 104.537 276.469L214.056 284.127C216.329 284.286 217.465 284.366 218.298 284.875C219 285.305 219.553 285.941 219.881 286.696C220.27 287.592 220.19 288.728 220.031 291.001L214.698 367.268C214.539 369.54 214.46 370.677 213.95 371.51C213.52 372.212 212.885 372.765 212.129 373.093C211.233 373.481 210.097 373.402 207.825 373.243L98.3053 365.585C96.0329 365.426 94.8967 365.346 94.0632 364.837C93.3609 364.407 92.8082 363.771 92.4806 363.016C92.0918 362.12 92.1713 360.984 92.3302 358.711L97.6633 282.444Z"
          fill="#CEFAFE"
        />
        <rect
          x="109.795"
          y="338.32"
          width="52"
          height="4"
          rx="2"
          transform="rotate(4 109.795 338.32)"
          fill="#00D3F3"
        />
        <rect
          x="109.237"
          y="346.3"
          width="28"
          height="4"
          rx="2"
          transform="rotate(4 109.237 346.3)"
          fill="#00D3F3"
        />
        <path
          d="M224.021 291.28C224.18 289.007 224.26 287.871 224.77 287.038C225.199 286.336 225.835 285.783 226.59 285.455C227.486 285.066 228.623 285.146 230.895 285.305L340.414 292.963C342.687 293.122 343.823 293.202 344.656 293.711C345.359 294.141 345.911 294.777 346.239 295.532C346.628 296.428 346.548 297.564 346.389 299.837L341.056 376.104C340.897 378.376 340.818 379.512 340.308 380.346C339.879 381.048 339.243 381.601 338.488 381.928C337.591 382.317 336.455 382.238 334.183 382.079L224.663 374.421C222.391 374.262 221.255 374.182 220.421 373.672C219.719 373.243 219.166 372.607 218.839 371.852C218.45 370.956 218.529 369.819 218.688 367.547L224.021 291.28Z"
          fill="#FFEDD4"
        />
        <rect
          x="235.595"
          y="355.136"
          width="72"
          height="4"
          rx="2"
          transform="rotate(4 235.595 355.136)"
          fill="#FF8904"
        />
        <path
          d="M350.38 300.116C350.539 297.843 350.618 296.707 351.128 295.874C351.557 295.171 352.193 294.619 352.948 294.291C353.845 293.902 354.981 293.982 357.253 294.141L466.772 301.799C469.045 301.958 470.181 302.037 471.014 302.547C471.717 302.977 472.269 303.612 472.597 304.368C472.986 305.264 472.906 306.4 472.747 308.673L467.414 384.94C467.255 387.212 467.176 388.348 466.666 389.182C466.237 389.884 465.601 390.437 464.846 390.764C463.949 391.153 462.813 391.074 460.541 390.915L351.022 383.256C348.749 383.097 347.613 383.018 346.78 382.508C346.077 382.079 345.525 381.443 345.197 380.688C344.808 379.791 344.888 378.655 345.047 376.383L350.38 300.116Z"
          fill="#FFE4E6"
        />
        <rect
          x="361.953"
          y="363.972"
          width="52"
          height="4"
          rx="2"
          transform="rotate(4 361.953 363.972)"
          fill="#FF637E"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_10235_2180"
          x="-0.927002"
          y="-1"
          width="579.953"
          height="487.172"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="40" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10235_2180"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_10235_2180"
            result="effect2_dropShadow_10235_2180"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_10235_2180"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
